module.exports = __webpack_public_path__ + "img/D201409_1.116fa094.jpg";